import { ModalContent, ModalFooter } from '@components/secondary-modal';

const genericSecondaryModal = ({
  msg,
  title,
  onSave,
  saveText = 'Close',
  cancelText,
  hasCloseButton = true,
  size = 'lg',
}) => (
  <ModalContent size={size} hasCloseButton={hasCloseButton} title={title}>
    <section className='modal-body'>
      <div style={{ wordWrap: 'break-word' }}>{msg}</div>
    </section>
    <ModalFooter saveText={saveText} showCancelButton={cancelText} onSave={onSave} cancelText={cancelText} />
  </ModalContent>
);
export default genericSecondaryModal;
